export default "__VITE_ASSET__SFySaRrN__"